import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  standalone:true,
  selector: 'app-login',
  imports: [ReactiveFormsModule, TranslateModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  // This method is used to initialize the class instance using fb, router, and oauth service
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private oauthService:OAuthService 
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
    
  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    this.oauthService.initCodeFlow();
  }

  // This method is used to log in with uae pass
  loginWithUaePass() {

  }
  // This method is used to log in
  login() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    const { username, password } = this.loginForm.value;
    const fakeUser = { id: 1, username: 'John Doe', email: username! };
    const fakeToken = '12345';
    // this.store.dispatch(loginSuccess({ user: fakeUser, token: fakeToken }));
    this.router.navigate(["/membership"]);
  }
}
